module.exports = __webpack_public_path__ + "img/alert-triangle.d894bf00.svg";